import { render, staticRenderFns } from "./deliveryInfo.vue?vue&type=template&id=c59b1cec&scoped=true&"
import script from "./deliveryInfo.vue?vue&type=script&lang=js&"
export * from "./deliveryInfo.vue?vue&type=script&lang=js&"
import style0 from "./deliveryInfo.vue?vue&type=style&index=0&id=c59b1cec&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c59b1cec",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SvgIcon: require('/app/components/svgIcon/svgIcon.vue').default})
